import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callProductContentGetApi = async (payload) => {
  const { data = [] } = await axiosInstanceClient.get(API.productcontent, {
    headers: {

      clientId: "shopidfc"
    },
    params:{
    pageSize:payload?.pageSize,
    pageNumber:payload?.pageNumber,
}
  });
  return data;
};